import React, { useState } from 'react';
import SecondaryButton from '../../components/ui/SecondaryButton';
import AppStoreCard from '../../components/ui/AppStoreCard';
import img from '../../assets/img/img.png';
import { useNavigate } from 'react-router-dom';
import FeatureCard from '../../components/ui/FeatureCard';
import examplePhoto from '../../assets/img/examplePhoto.png';
import notificationPhoto from '../../assets/img/notificationPhoto.png';
import qrCodePhoto from '../../assets/img/qrCodePhoto.png';
import AIPhoto from '../../assets/img/AIPhoto.png';
import googleAnalyticsPhoto from '../../assets/img/googleAnalyticsPhoto.png';
import metaPixelPhoto from '../../assets/img/MetaPixelPhoto.png';
import wheelPhoto from '../../assets/img/wheelPhoto.png';
import EpostaPhoto from '../../assets/img/EpostaPhoto.png';
import PopupPhoto from '../../assets/img/PopupPhoto.png';
import { SVG_PIP_2_Linear, SVG_Transmission_Square_Linear } from '@dev-mobligo/iconpack';

const FeatureStore = () => {
  const navigate = useNavigate();
  const categories = [
    { name: "Aktif Özellikler", id: "activeFeatures" },
    { name: "Aktif Olmayan Özellikler", id: "deactiveFeatures" },

  ];
  const applications = [

    {
      name: "Smart Banner",
      category: "Aktif Özellikler",
      description: "Zamanlanabilir Pop-up’lar ile satışlarını arttır.     ",
      img: SVG_PIP_2_Linear,
      isCompany: false,
    },
    {
      name: "App Badge",
      category: "Aktif Özellikler",
      description: "Zamanlanabilir Pop-up’lar ile satışlarını arttır.     ",
      img: SVG_Transmission_Square_Linear,
      isCompany: false
    },
    // {
    //   name: "E-Posta Pazarlama",
    //   category: "Aktif Özellikler",
    //   description: "E-Posta kampanyaları oluşturarak müşterilerinizi özel fırsatlar hakkında bilgilendirin.       ",
    //   img: EpostaPhoto,
    //   isCompany: true
    // },
    // {
    //   name: "Push Notification",
    //   category: "Aktif Özellikler",
    //   description: "Uygulama bildirimleri ile kullanıcılarınızı sürekli yeniliklerden ve kampanyalardan haberdar edin. ",
    //   img: notificationPhoto,
    //   isCompany: true
    // },
    // {
    //   name: "Barkod Okuma",
    //   category: "Aktif Özellikler",
    //   description: "Kullanıcılarınızın ürünlerin barkodlarını okutarak uygulama içinde aynı ürünü bulmalarını sağlayın.",
    //   img: qrCodePhoto,
    //   isCompany: false
    // },

    // {
    //   name: "Yapay Zeka ile Ürün Açıklaması Oluşturma",
    //   category: "Aktif Olmayan Özellikler",
    //   description: "Yapay zeka araçlarını kullanarak ürün hızlıca ürün açıklaması yazabilirsiniz.             ",
    //   img: AIPhoto,
    //   isCompany: false
    // },
    // {
    //   name: "Google Analytics",
    //   category: "Aktif Olmayan Özellikler",
    //   description: "Uygulamanızın trafik ve kullanıcı verilerini analiz edebilirsiniz.               ",
    //   img: googleAnalyticsPhoto,
    //   isCompany: true
    // },
    // {
    //   name: "Meta Pixel (Conversions API)",
    //   category: "Aktif Olmayan Özellikler",
    //   description: "Dönüşümleri Meta’nın takip etmesini sağlayarak reklamlarınızın verimliliğini artırabilirsiniz.                 .     ",
    //   img: metaPixelPhoto,
    //   isCompany: true
    // },
    // {
    //   name: "Çekiliş Çarkı Kampanyası          ",
    //   category: "Aktif Olmayan Özellikler",
    //   description: "Kullanıcılara uygulamada bir çekiliş çarkı göstererek indirim verebilirsiniz.                   ",
    //   img: wheelPhoto,
    //   isCompany: false
    // },
  ];

  const [filteredCategories, setFilteredCategories] = useState(
    categories.map((category) => ({
      ...category,
      apps: applications.filter((app) => app.category === category.name),
    }))
  );

  return (
    <div>
      <div className='p-[20px] overflow-hidden'>
        <div >
          <div className='overflow-hidden'>
            <div id='' className='max-h-[75vh]  flex overflow-y-auto flex-col '>
              <div className='block h-[0px]' id='top'></div>
              <div className='' >
                <span className='mb-[20px] block'>Aktif Özellikler</span>
                <div className='grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-4'>
                  {applications.map((app, index) => (
                    <FeatureCard

                      key={index}
                      isCompany={app.isCompany}
                      CardImg={app.img}
                      cardName={app.name}
                      cardDesc={app.description}
                      cardCategory={app.category}
                    />
                  ))}
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default FeatureStore;





{/* <FeatureCard isLocked={app.isLocked} key={index} cardName={app.name} cardCategory={app.category} cardDesc={app.descripton} cardImg={app.img} /> */ }
